import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/mic-off.vue
var s = {
	name: "DtIconMicOff",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--mic-off"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Mic Off",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M.646.646a.5.5 0 0 1 .708 0l7.5 7.5 2.5 2.5a.5.5 0 0 1-.708.708L8.481 9.188a4 4 0 0 1-1.981.832V11H8a.5.5 0 0 1 0 1H4a.5.5 0 0 1 0-1h1.5v-.98A4.001 4.001 0 0 1 2 5.996V5a.5.5 0 0 1 1 0v1.007a3 3 0 0 0 4.768 2.468l-.753-.753A2 2 0 0 1 4 6V4.707L.646 1.354a.5.5 0 0 1 0-.708ZM5 5.707V6a1 1 0 0 0 1.258.965L5 5.707Zm.153-5.01A2 2 0 0 1 8 2.497V4.67a.5.5 0 0 1-1 0V2.502a1 1 0 0 0-1.893-.442.5.5 0 0 1-.894-.45 2 2 0 0 1 .94-.913ZM9.5 4.5a.5.5 0 0 1 .5.5v1.001c0 .235-.022.47-.063.702a.5.5 0 1 1-.984-.176A3.06 3.06 0 0 0 9 6V5a.5.5 0 0 1 .5-.5Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=mic-off.js.map